import React from 'react';
import { useDispatch } from 'react-redux';
import { updateItem,editMenuItem } from '../../redux/action';
import { Link, useNavigate } from 'react-router-dom';
import { pathUpdateWithExtention } from '../../Utills/utils';

// A simple SVG for an edit (pencil) icon
const PencilIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
  </svg>
);

const EditIcon = ({ onClick, label = 'Edit', className = '', style = {}, size = 24, color = '#333' }) => {
  const iconContainerStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: onClick ? 'pointer' : 'default', // Only show pointer if clickable
    padding: '5px',
    borderRadius: '4px',
    transition: 'background-color 0.2s ease-in-out',
    userSelect: 'none', // Prevent text selection on click
    ...style, // Allow custom styles to be passed
  };

  const textStyle = {
    marginLeft: label ? '8px' : '0', // Add margin if there's a label
    fontSize: '14px',
    color: color,
  };

  return (
    <div
      role="button" // Indicates it's interactive for accessibility
      tabIndex={onClick ? 0 : -1} // Make it focusable if clickable
      onClick={onClick}
      className={`edit-icon-component ${className}`} // Add a base class and allow extra classes
      style={iconContainerStyle}
      aria-label={label === 'Edit' ? 'Edit item' : label} // More descriptive for screen readers
      onKeyPress={(e) => { // Accessibility: allow activation with Enter/Space
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <PencilIcon size={size} color={color} />
      {label && <span style={textStyle}>{label}</span>}
    </div>
  );
};


const ItemEdit = ({ menuId, tab, unit, isAvailable }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const handleStatusUpdate = () => {
      console.log("itemeditpage...........",menuId + " and " + unit)
      //  dispatch(updateItem({ id: id, selectedTab: tab })); 
        dispatch(editMenuItem(unit));
        navigate(pathUpdateWithExtention('menu-edit'))
    };

    return (
        <>
            <EditIcon onClick={handleStatusUpdate}/>
        </>
    )
};

export default ItemEdit;